// composables/useIframeTheme.ts
import type { Theme } from '@/store/modules/app/helper'

export const useIframeTheme = () => {
  const sendThemeToIframes = (theme: Theme) => {
    const iframes = document.querySelectorAll('iframe[data-theme-sync="true"]')

    iframes.forEach((iframe) => {
      if (iframe instanceof HTMLIFrameElement && iframe.contentWindow) {
        iframe.contentWindow.postMessage({
          type: 'THEME_UPDATE',
          theme,
        }, '*')
      }
    })
  }

  return {
    sendThemeToIframes,
  }
}
